var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 1.89844H13.2578C13.2031 1.22656 12.7969 0.867188 12.0781 0.867188H5.05469C4.33594 0.867188 3.92969 1.22656 3.875 1.89844ZM2.38281 4.0625H14.75C14.6484 3.35156 14.2812 2.94531 13.4766 2.94531H3.65625C2.85156 2.94531 2.48438 3.35156 2.38281 4.0625ZM3.27344 17.4609H13.8594C15.4141 17.4609 16.2422 16.6328 16.2422 15.0859V7.64062C16.2422 6.09375 15.4141 5.27344 13.8594 5.27344H3.27344C1.70312 5.27344 0.882812 6.09375 0.882812 7.64062V15.0859C0.882812 16.6406 1.70312 17.4609 3.27344 17.4609ZM8.58594 12.4688C7.33594 12.4531 6.375 11.4141 6.36719 10.0469C6.36719 8.75 7.34375 7.67188 8.58594 7.67188C9.82031 7.67188 10.7969 8.75 10.7969 10.0469C10.7969 11.4141 9.82812 12.4766 8.58594 12.4688ZM4.42188 15.9609C5 14.4922 6.63281 13.4766 8.58594 13.4766C10.5312 13.4766 12.1641 14.4922 12.75 15.9609H4.42188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon);
export default __webpack_public_path__ + "static/media/missionIcon.fa354dfa25091f8af37b0dd6f813b121.svg";
export { ForwardRef as ReactComponent };